var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab"},_vm._l((_vm.homePageTabList),function(item,index){return _c('div',{key:index,staticClass:"tab-div",class:{ 'tab-active': item.isActive },on:{"click":function($event){return _vm.changeTab(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }